import React from "react";

export const getImgOrDocTag = (img_src, file_type, maxWidth, maxHeight) => {
    var file_type = file_type.toLowerCase();
    if(file_type === "png" || file_type === "gif" || file_type === "jpg" || file_type === "jpeg") {

        if(img_src === "") img_src = require('../images/icons/filetype/file.png');
    } else if(file_type === "doc") {
        img_src = require('../images/icons/filetype/doc.png');
    } else if(file_type === "pdf") {
        img_src = require('../images/icons/filetype/pdf.png');
    } else if(file_type === "mp4" || file_type === "mov" || file_type === "m4v") {
        img_src = require('../images/icons/filetype/mp4.png');
    } else if(file_type === "file") {
        img_src = require('../images/icons/filetype/file.png');
    }
     else
        img_src = require('../images/icons/filetype/file.png');

    var tag = <img id="target" src={img_src} className="clientNewProfilePhoto" style={{maxHeight: maxHeight, maxWidth: maxWidth, objectFit:'cover'}}/>
    return tag;
}



// WEBPACK FOOTER //
// ./src/utils/ImageUpload.js